var _style, _defs, _clipPath, _defs2, _clipPath2, _defs3, _clipPath3, _defs4, _clipPath4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElastic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    viewBox: "0 0 80 80",
    width: 2500,
    height: 2500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n        .st0{clip-path:url(#SVGID_2_);fill:#f0bf1a}.st1{clip-path:url(#SVGID_4_);fill:#3ebeb0}.st2{clip-path:url(#SVGID_6_);fill:#07a5de}.st3{clip-path:url(#SVGID_8_);fill:#231f20}.st4{fill:#d7a229}.st5{fill:#019b8f}.st6{fill:none}\n    ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 40,
    cy: 40,
    r: 32
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.7 26H10c-1.1 0-2-.9-2-2V10c0-1.1.9-2 2-2h57c1.1 0 2 .9 2 2v.7C68.9 19.1 62.1 26 53.7 26z",
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#f0bf1a"
    }
  }), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_3_",
    cx: 40,
    cy: 40,
    r: 32
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.1 72H8.2V54h45.7c8.4 0 15.2 6.8 15.2 15.2V72z",
    style: {
      clipPath: "url(#SVGID_4_)",
      fill: "#3ebeb0"
    }
  }), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_5_",
    cx: 40,
    cy: 40,
    r: 32
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.1 49H4.8V31h45.3c5 0 9 4 9 9s-4.1 9-9 9z",
    style: {
      clipPath: "url(#SVGID_6_)",
      fill: "#07a5de"
    }
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_7_",
    cx: 40,
    cy: 40,
    r: 32
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M36 31H6.4v18H36c.7-2.7 1.1-5.7 1.1-9s-.4-6.3-1.1-9z",
    style: {
      clipPath: "url(#SVGID_8_)",
      fill: "#231f20"
    }
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M23.9 12.3c-5.4 3.2-9.9 8-12.7 13.7h23.6c-2.4-5.5-6.2-10.1-10.9-13.7z",
    style: {
      fill: "#d7a229"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M24.9 68.2c4.6-3.7 8.3-8.6 10.6-14.2H11.2c3 6 7.8 11 13.7 14.2z",
    style: {
      fill: "#019b8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M0 0h80v80H0z",
    style: {
      fill: "none"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElastic);
export default __webpack_public_path__ + "static/media/elastic.af6c1c45818c0b53731b02b77a9bef02.svg";
export { ForwardRef as ReactComponent };